import axios from 'axios';

export default class ActivateService {

  public activateAccount(key: string): Promise<any> {
    return axios.get(`api/public/activate?key=${key}`);
  }
}
